import { useEffect } from "react";
import { trackConversion } from "@/lib/openai-ads";

const PIXEL_ID = "CM1RXP65GwBBSCxcq2jkFH";

/**
 * OpenAI / ChatGPT Ads base pixel, mounted exactly once from the root route.
 * The `window.oaiq` guard keeps client-side route changes from re-initializing
 * it. Also owns the single delegated listener that tracks `tel:` / `sms:`
 * clicks anywhere on the site.
 */
export function OpenAiPixel() {
  useEffect(() => {
    if (typeof window === "undefined") return;

    if (!window.oaiq) {
      (function (w: any, d: Document, s: string, u: string) {
        if (w.oaiq) return;
        const q: any = function () {
          // eslint-disable-next-line prefer-rest-params
          q.q.push(arguments);
        };
        q.q = [];
        w.oaiq = q;
        const j = d.createElement(s) as HTMLScriptElement;
        j.async = true;
        j.src = u;
        const f = d.getElementsByTagName(s)[0];
        f.parentNode?.insertBefore(j, f);
      })(window, document, "script", "https://bzrcdn.openai.com/sdk/oaiq.min.js");

      (window as any).oaiq?.("init", { pixelId: PIXEL_ID, debug: false });
    }

    function onClick(e: MouseEvent) {
      const target = e.target as Element | null;
      const anchor = target?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!anchor) return;
      const href = (anchor.getAttribute("href") || "").trim().toLowerCase();
      const type = href.startsWith("tel:")
        ? ("call_click" as const)
        : href.startsWith("sms:")
          ? ("text_click" as const)
          : null;
      if (!type) return;
      // Fires synchronously, before the browser hands off to the dialer.
      // The bucketed key collapses capture/bubble duplicates of one click.
      trackConversion(type, {
        dedupeKey: `${type}:${href}:${Math.floor(Date.now() / 1500)}`,
      });
    }

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
